import { useState } from "react";
import { Form, Row } from 'react-bootstrap';
import styled from 'styled-components';
import { RiSearchLine } from 'react-icons/ri';
import { openLink } from 'helpers/general';
import { CustomButton } from 'components/CustomForm';
import { OneLineLabel } from 'components/CommonWidgets';
import { useQuery } from "react-query";
import { getStoreReport } from 'network/apis/ReportingApi';

const ResultBox = styled.div`
	border: 1px solid black;
	border-radius: 8px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 1rem 1rem;
`;

const SearchInput = styled(Form.Control)`
    padding: 1.5rem;
    text-align: center;
    border-radius: 8px;
    width: 15rem;    
`;

const Holder = styled.div`
    display: flex;
    justify-content: space-evenly;
    align-items: center;
`;

const VDivider = styled.div`
	width: 1px;
    height: 5rem;
	background-color: #C6C6C6;
`;

const StoreTabMenu = ({ tabData, parentType }) => {
    const getInputsCount = () => `${tabData?.sum ?? 0}`.persianCurrency();
    const getTypesCount = () => `${tabData?.count ?? 0}`.persianCurrency();

    const { refetch: fetchTableExcel } = useQuery(
		[`${parentType}-export-store-excel`],
		() => getStoreReport('?excel=true'),
		{
			refetchOnWindowFocus: false,
			enabled: false,
			onSuccess: (data) => {
				const url = data?.data?.url;
				if (url) openLink(url);
			},
		}
	);

	const downloadTableExcel = () => {
		fetchTableExcel();
	};

    return (
        <Holder>
            <CustomButton
                fontSize={10}
                onClick={downloadTableExcel}
                color='#0278EE'
                
            >
                اکسل جدول
            </CustomButton>
            <VDivider />
            <OneLineLabel>مجموع نهاده های موجود در انبار  : {getInputsCount()} تن</OneLineLabel>
            <VDivider />
            <OneLineLabel>انواع نهاده های موجود در انبار  : {getTypesCount()} نوع</OneLineLabel>
        </Holder>
    );
};

export default StoreTabMenu;